import { apiRTK } from "../apiRTK";
import { IMLResult, ISpaceTrainingDataInput } from "../types/types";

export const PYCEILING_BASE_URL =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5001/api"
    : "https://mcapps-test.multiconsult.no/pyapi";

// export interface IGetMcBimSpaceArgs {
//   projectNo: string;
//   jobId: string | undefined;
//   floorGlobalId: string | undefined;
//   token: string | undefined;
// }

export interface ISpaceAirFlow {
  spaceNumber: string; // "01.01.007",
  spaceLongName: string; //
  supplyAirFlow: number; // 170
  returnAirFlow: number; // 170
}

export const designRTK = apiRTK.injectEndpoints({
  endpoints: (builder) => ({
    getListWithTrainedStandardRoomModelsInPyCeiling: builder.query<string[], void>({
      query: () => ({
        url: `${PYCEILING_BASE_URL}/list-trained-standard-room-models`,
        method: "GET",
      }),
      providesTags: ["TrainedStandardRooms"],
    }),
    trainStandardSpace: builder.mutation<IMLResult[], { inputMl: ISpaceTrainingDataInput | null }>({
      query: (input) => ({
        url: `${PYCEILING_BASE_URL}/train-standard-space`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          standardSpace: input.inputMl,
        },
      }),
      invalidatesTags: ["SavedRooms", "PredictSpace"],
    }),
    trainAllStandardSpacesBackend: builder.mutation<
      string,
      {
        standardSpacesTrainingDataInput: ISpaceTrainingDataInput[];
      }
    >({
      query: (input) => ({
        url: `${PYCEILING_BASE_URL}/train-all-standard-spaces`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          standardSpaces: input.standardSpacesTrainingDataInput,
        },
      }),
    }),
    getTrainingStatus: builder.query<
      {
        training_in_progress: boolean;
        trained_count: number;
        failed_count: number;
        remaining_count: number;
      },
      string
    >({
      query: () => ({
        url: `${PYCEILING_BASE_URL}/training-status`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetTrainingStatusQuery,
  useGetListWithTrainedStandardRoomModelsInPyCeilingQuery,
  useTrainStandardSpaceMutation,
} = designRTK;

const addOneMeterToPolygon = (polygon: number[][]): number[][] => {
  return polygon.map((point) => {
    return [point[0] + 1, point[1]];
  });
};
